<template>
  <div class="usercard">
    <div class="signup-pic"></div>
    <div class="avatar">
      <div class="avatar-border"><el-icon size="30px" color="#cdcdcd">
          <User />
        </el-icon></div>
      <div>上传头像</div>
    </div>
    <input placeholder="邮箱" v-model="signupinfo.mail" />
    <input placeholder="用户名" v-model="signupinfo.nickname" />
    <input type="password" placeholder="设置密码" v-model="signupinfo.passwd" />
    <input type="password" placeholder="请确认密码" v-model="signupinfo.passwd2" />
    <input placeholder="职业" v-model="signupinfo.job" />
    <input placeholder="地区" v-model="signupinfo.region" />
    <el-button style="margin-top: 10px;" color="#ff7d00" @click="gosignup()"><span
        style="color: white;">确认</span></el-button>
    <div class="gologin" id="gologin" @click="changesignup">
      已有账号？立即登录
    </div>
  </div>
</template>

<script setup lang="ts">
import { userinfo } from '@/stores/counter'
import usesignup from '@/api/getSignup'
import { reactive } from 'vue';
import { ElMessage } from 'element-plus'

const { signup } = usesignup();
const user = userinfo()

const signupinfo = reactive({
  phone: '',
  mail: '',
  nickname: '',
  passwd: '',
  passwd2: '',
  avatar: "C:\\Users\\13918\\Desktop\\解困首页\\tz-syyh\\public\\assets\\imgs\\avatar.png",
  job: '',
  region: ''
})

function gosignup() {
  if (signupinfo.passwd2 != signupinfo.passwd) {
    ElMessage({
      showClose: true,
      message: '两次输入密码不一致！',
      type: 'error',
    })
  } else {
    signup(signupinfo.phone, signupinfo.mail, signupinfo.nickname, signupinfo.passwd, signupinfo.avatar, signupinfo.region, signupinfo.job)
  }
}

function changesignup() {
  user.signup = !user.signup
}
</script>

<style scoped>
.usercard {
  width: 460px;
  height: fit-content;
  background-color: white;
  /* background-color: red; */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  border-radius: 10px;
  box-shadow:
    2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
    6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
    22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
    41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05),
    100px 100px 80px rgba(0, 0, 0, 0.07)
}

.signup-pic {
  background-image: url(/assets/imgs/signup.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 70px;
  width: 160px;
  margin: 50px 0 20px;
}

.avatar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #cdcdcd;
  cursor: pointer;
}

.avatar-border {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border: 3px #cdcdcd solid;
}

.usercard>input {
  display: flex;
  width: calc(70%);
  margin: 10px;
  padding: 5px 10px;
  height: 40px;
  border: 1px #bfbdbe solid;
  border-radius: 5px;
  font-size: 18px;
}

.usercard>input::placeholder {
  color: #bfbdbe;
}

.usercard>input:focus {
  outline: none;
  /* 可选，去除选中时的默认外边框 */
}

.gologin {
  color: #c6c0c0;
  margin: 20px 0 40px;
  text-decoration: underline;
  cursor: pointer;
}
</style>